import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAuth } from "./Authentication/AuthContext";
import api from "../api/axiosConfig.js";
import { ProjectContext } from "../App.js";
import StatusPieChart from "./Home/ProjectStatusPie.js";
import ProjectManagerBarChart from "./Home/ProjectManager.js";
import ProjectCustomerBarChart from "./Home/ProjectCustomerBarchart.js";
import ProjectTimelineSummary from "./Home/ProjectTimelineSummary.js";
import GroupPieChart from "./Home/GroupsPieChart.js";
import DurationCalendar from "../components/Home/DurationCalendar.js";
import "../styles/projects/Dashboard.css";
import "../styles/Home.css";
import socket from "../socket.js";

const Home = () => {
  const { isNavBarOpen } = useContext(ProjectContext);
  const [projects, setProjects] = useState([]);
  const [activeProjects, setActiveProjects] = useState([]);
  const [completedProjects, setCompletedProjects] = useState([]);
  const [clientCompanies, setClientCompanies] = useState([]);
  const [associatedGroups, setAssociatedGroups] = useState([]);
  const [overAllVariations, setOverAllVariations] = useState([]);
  const [phases, setPhases] = useState([]);
  const [rfis, setRfis] = useState([]);
  const openRfis = rfis?.filter((r) => r.rfi_status === "Open")?.length;
  const closedRfis = rfis?.filter((r) => r.rfi_status === "Closed")?.length;
  const outstandingRfis = rfis?.filter(
    (r) => r.rfi_status === "Outstanding"
  )?.length;
  const [filterPhases, setFilterPhases] = useState([]);
  const [companiesCount, setCompaniesCount] = useState(0);
  const [activeProjectsCount, setActiveProjectsCount] = useState(0);
  const [completedProjectsCount, setCompletedProjectsCount] = useState(0);
  const [associatedGroupsCount, setAssociatedGroupsCount] = useState(0);
  const [ucVoCount, setUcVoCount] = useState(0);
  const [unaccpetedVoCount, setUnacceptedVoCount] = useState(0);
  const [confirmedVoCount, setConfirmedVoCount] = useState(0);
  const [unApprovedVoCount, setUnapprovedVoCount] = useState(0);
  const [openRfisCount, setOpenRfisCount] = useState(0);
  const [outstandingRfisCount, setOutstandingRfisCount] = useState(0);
  const targetCompaniesCount = clientCompanies.length;
  const targetActiveProjectsCount = activeProjects.length;
  const targetCompletedProjectsCount = completedProjects.length;
  const targetAssociatedGroupsCount = associatedGroups.length;
  const targetUcVoCount = overAllVariations.filter(
    (v) => v.invoice_status === "Unclaimed"
  ).length;
  const targetUnacceptedVoCount = overAllVariations.filter(
    (v) => v.variation_status === "Waiting"
  ).length;
  const targetAcceptedVoCount = overAllVariations.filter(
    (v) => v.variation_status === "Accepted"
  ).length;
  const targetUnapprovedVoCount = overAllVariations.filter(
    (v) => v.variation_status === "Confirmed"
  ).length;
  useEffect(() => {
    const fetchCompaniesCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetCompaniesCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setCompaniesCount(start);
        if (start >= targetCompaniesCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchActiveprojectsCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetActiveProjectsCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setActiveProjectsCount(start);
        if (start >= targetActiveProjectsCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchCompletedprojectsCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetCompletedProjectsCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setCompletedProjectsCount(start);
        if (start >= targetCompletedProjectsCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchAssociatedGroupsCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetAssociatedGroupsCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setAssociatedGroupsCount(start);
        if (start >= targetAssociatedGroupsCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchUcVoCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetUcVoCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setUcVoCount(start);
        if (start >= targetUcVoCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchUnaccpetedVoCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetUnacceptedVoCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setUnacceptedVoCount(start);
        if (start >= targetUnacceptedVoCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchAcceptedVoCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetAcceptedVoCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setConfirmedVoCount(start);
        if (start >= targetAcceptedVoCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchUnapprovedVoCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / targetUnapprovedVoCount, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setUnapprovedVoCount(start);
        if (start >= targetUnapprovedVoCount) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchOpenRfisCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / openRfis, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setOpenRfisCount(start);
        if (start >= openRfis) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    const fetchOutstandingRfisCount = () => {
      let start = 0;
      const duration = 500; // total animation duration in ms
      const stepTime = Math.max(duration / outstandingRfis, 50); // delay between increments

      const interval = setInterval(() => {
        start += 1;
        setOutstandingRfisCount(start);
        if (start >= outstandingRfis) clearInterval(interval);
      }, stepTime);

      return () => clearInterval(interval);
    };
    if (targetCompaniesCount) {
      fetchCompaniesCount();
    }
    if (targetActiveProjectsCount) {
      fetchActiveprojectsCount();
    }
    if (targetCompletedProjectsCount) {
      fetchCompletedprojectsCount();
    }
    if (targetAssociatedGroupsCount) {
      fetchAssociatedGroupsCount();
    }
    if (targetUcVoCount) {
      fetchUcVoCount();
    }
    if (targetAcceptedVoCount) {
      fetchAcceptedVoCount();
    }
    if (targetUnapprovedVoCount) {
      fetchUnapprovedVoCount();
    }
    if (targetUnacceptedVoCount) {
      fetchUnaccpetedVoCount();
    }
    if (openRfis) {
      fetchOpenRfisCount();
    }
    if (outstandingRfis) {
      fetchOutstandingRfisCount();
    }
  }, [
    targetCompaniesCount,
    targetActiveProjectsCount,
    targetCompletedProjectsCount,
    targetAssociatedGroupsCount,
    targetUcVoCount,
    targetAcceptedVoCount,
    targetUnapprovedVoCount,
    openRfis,
    outstandingRfis,
  ]);

  useEffect(() => {
    const newPhase = phases
      .filter((ph) =>
        projects.some((p) => Number(p.id) === Number(ph.project_id))
      )
      .map((ph) => {
        const matchedProject = projects.find(
          (p) => Number(p.id) === Number(ph.project_id)
        );
        return {
          ...ph,
          project_start_date: matchedProject?.start_date || null,
        };
      });

    setFilterPhases(newPhase);
  }, [phases, projects]);
  const [statusOptions, setStatusOption] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userDetails } = useAuth();
  const userID = userDetails.id;
  const username = userDetails.name;

  useEffect(() => {
    socket.on("connect", () => {});
    socket.on("project details updated", (updatedProject) => {
      const fetchNewData = async () => {
        try {
          // Fetch both project datasets in parallel
          let projectDataRes, timesheetDataRes;

          if (
            userDetails.role_name === "Administrator" ||
            userDetails.role_name === "Super Admin"
          ) {
            [projectDataRes, timesheetDataRes] = await Promise.all([
              api.get("/api/projectlistdata"),
              api.get("/api/projectlist/timesheets"),
            ]);
          } else {
            [projectDataRes, timesheetDataRes] = await Promise.all([
              api.get(`/api/projectlistdata/${userID}`),
              api.get(`/api/projectlist/timesheets/${userID}`),
            ]);
          }

          let projectData = projectDataRes.data;
          let timesheetData = timesheetDataRes.data;

          // Find the newly edited project in the updated project list
          const newlyEditedProject = projectData.find(
            (ph) => ph.id === Number(updatedProject.id)
          );
          if (!newlyEditedProject) return; // Ensure the project exists

          // Find matching timesheet data for the newly edited project
          const matchingTimesheet = timesheetData.find(
            (timesheet) => timesheet.project_id === newlyEditedProject.id
          );

          // Merge project data with its corresponding timesheet data
          const updatedProjectData = {
            ...newlyEditedProject,
            ...matchingTimesheet, // Merge timesheet data if found
          };

          // Update the state with the newly edited project data
          setProjects((prev) =>
            prev.map((p) =>
              p.id === Number(updatedProjectData.id) ? updatedProjectData : p
            )
          );
        } catch (error) {
          setError(error);
          console.error("Error fetching project data:", error.message || error);
        }
      };
      if (updatedProject) {
        fetchNewData();
      }
    });

    socket.on("phase details updated", (updatedPhase) => {
      const fetchNewData = async () => {
        try {
          const res = await api.get("/api/project/workinprogresslist");
          const newlyEditedPhase = res.data.find(
            (ph) => ph.id === Number(updatedPhase.id)
          );
          if (!newlyEditedPhase) return; // Ensure the estimate exists

          setPhases((prev) =>
            prev.map((p) =>
              p.id === Number(newlyEditedPhase.id) ? newlyEditedPhase : p
            )
          );
        } catch (error) {
          setError(error);
          console.error("Error fetching project data:", error.message || error);
        } finally {
        }
      };
      if (updatedPhase) {
        fetchNewData();
      }
    });
    return () => {
      socket.off("project details updated");
      socket.off("phase details updated");
    };
  }, []);

  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return "Good morning,";
    } else if (currentHour < 16) {
      return "Good afternoon";
    } else {
      return "Good evening";
    }
  };
  const greeting = getGreeting();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch both project and timesheet data based on user role
        let projectDataRes, timesheetDataRes, rfiRes;

        if (
          userDetails.role_name === "Administrator" ||
          userDetails.role_name === "Super Admin"
        ) {
          [projectDataRes, timesheetDataRes, rfiRes] = await Promise.all([
            api.get("/api/projectlistdata"),
            api.get("/api/projectlist/timesheets"),
            api.get(`/api/rfis`),
          ]);
        } else {
          [projectDataRes, timesheetDataRes, rfiRes] = await Promise.all([
            api.get(`/api/projectlistdata/${userID}`),
            api.get(`/api/projectlist/timesheets/${userID}`),
            api.get(`/api/rfis/${userID}`),
          ]);
        }

        setRfis(rfiRes.data);
        const varurl =
          userDetails.role_name === "Administrator" ||
          userDetails.role_name === "Super Admin"
            ? "/api/overall/variations"
            : `/api/overall/variations/${userDetails.id}`;

        // Fetch additional required data
        const phaseRes = await api.get("/api/project/workinprogresslist");
        const statusOptionRes = await api.get("/api/status");
        const variationsRes = await api.get(varurl);

        let projectData = projectDataRes.data;
        let timesheetData = timesheetDataRes.data;

        // Merge project data with timesheet data by matching project ID
        let mergedProjects = projectData.map((project) => {
          const matchingTimesheet = timesheetData.find(
            (timesheet) => timesheet.project_id === project.id
          );
          return {
            ...project,
            ...matchingTimesheet, // Merge timesheet fields if found
          };
        });

        // Filter only active projects
        const activeProjects = mergedProjects.filter(
          (project) => project.activestatus === 1
        );
        const completedProjects = projectData.filter(
          (project) => project.project_status === "Completed"
        );
        const activeProject = projectData.filter(
          (project) =>
            project.project_status !== "Completed" && project.activestatus === 1
        );
        const clientCompanies = [
          ...new Set(projectData.map((p) => p.customer_name)),
        ];
        const associatedgroups = [
          ...new Set(
            projectData.flatMap((p) => p.associated_groups || []) // flatten all groups into a single array
          ),
        ];
        // Set state with updated data
        setProjects(activeProjects);
        setCompletedProjects(completedProjects);
        setActiveProjects(activeProject);
        setClientCompanies(clientCompanies);
        setAssociatedGroups(associatedgroups);
        setOverAllVariations(variationsRes.data);
        setPhases(phaseRes.data);
        setStatusOption(statusOptionRes.data);
      } catch (error) {
        setError(error);
        console.error("Error fetching project data:", error.message || error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userDetails.role, userID]);

  return (
    <>
      <Helmet>
        <title>Msuite - Projects</title>
      </Helmet>
      {
        <div
          className={
            isNavBarOpen
              ? "fixed left-[72px] top-[46px] w-screen h-screen overflow-auto box-border no-scrollbar"
              : "fixed left-[2px] top-[50px] w-screen h-screen overflow-auto box-border no-scrollbar"
          }
        >
          <div className="h-[124px]">
            <h1
              className={
                isNavBarOpen
                  ? "relative top-0 left-[10px] text-sm sm:left-[15px] md:left-[21px] md:text-base font-normal"
                  : "relative top-0 left-[10px] text-sm sm:left-[15px] md:left-[21px] md:text-base font-normal"
              }
            >
              Welcome {username},<br />{" "}
              <span className="font-normal ml-[2px] text-xs">{greeting}</span>
            </h1>
            <div
              className={`flex flex-wrap w-[94vw] relative left-[1.3rem] items-center  md:flex-nowrap 
                ${isNavBarOpen ? "w-[94vw] gap-1.5" : "w-[97vw] gap-3.5"}`}
            >
              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "Active");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid rgb(76, 175, 80)" }}
              >
                <div className="flex flex-row items-center justify-between">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#4CAF50", fontSize: "16px" }}>
                      {activeProjectsCount}
                    </span>
                    <span className="hyperlink-span">Active Projects</span>
                  </h3>
                  <span className="inv-span">
                    <img src="/AppLayout/active.svg" className="h-[26px]" />
                  </span>
                </div>
              </Link>

              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "Completed");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid rgb(33, 150, 243)" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#2196F3" }}>
                      {completedProjectsCount}
                    </span>
                    <span className="hyperlink-span">Completed Projects</span>
                  </h3>
                  <span className="inv-span">
                    <img src="/AppLayout/completed.svg" className="h-[26px]" />
                  </span>
                </div>
              </Link>

              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "Customer");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid #f39df5" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#f39df5" }}>{companiesCount}</span>
                    <span className="hyperlink-span">Client Companies</span>
                  </h3>
                  <span className="inv-span">
                    <img
                      src="/AppLayout/ClientCompanies.png"
                      className="h-[26px]"
                    />
                  </span>
                </div>
              </Link>

              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "Team");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid rgb(156, 39, 176)" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#9C27B0" }}>
                      {associatedGroupsCount}
                    </span>
                    <span className="hyperlink-span">Project Teams</span>
                  </h3>
                  <span className="inv-span">
                    <img
                      src="/AppLayout/ProjectTeams.png"
                      className="h-[26px]"
                    />
                  </span>
                </div>
              </Link>

              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "UnclaimedVo");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid rgba(238, 48, 0, 0.6)" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#ee300099" }}>{ucVoCount}</span>
                    <span className="hyperlink-span">Unclaimed VO</span>
                  </h3>
                  <span className="inv-span">
                    <img
                      src="/AppLayout/unclaimedvo.svg"
                      className="h-[26px]"
                    />
                  </span>
                </div>
              </Link>
              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "UnacceptedVo");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid  #FFA500" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: " #FFA500" }}>
                      {unaccpetedVoCount}
                    </span>
                    <span className="hyperlink-span">Unaccepted VO</span>
                  </h3>
                  <span className="inv-span">
                    <img
                      src="/AppLayout/unacceptedVo.png"
                      className="h-[26px]"
                    />
                  </span>
                </div>
              </Link>
              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "VO to Confirm");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid #BA5023" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#BA5023" }}>{confirmedVoCount}</span>
                    <span className="hyperlink-span">Unconfirmed VO</span>
                  </h3>
                  <span className="inv-span">
                    <img
                      src="/AppLayout/yettoconfirm.png"
                      className="h-[26px]"
                    />
                  </span>
                </div>
              </Link>
              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "Unapproved VO");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid #6155F5" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#6155F5" }}>
                      {unApprovedVoCount}
                    </span>
                    <span className="hyperlink-span">Unapproved VO</span>
                  </h3>
                  <span className="inv-span">
                    <img
                      src="/AppLayout/UnapprovedVO.png"
                      className="h-[26px]"
                    />
                  </span>
                </div>
              </Link>
              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "Open RFIs");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid #8bbd18" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#8bbd18" }}>{openRfisCount}</span>
                    <span className="hyperlink-span">Open RFIs</span>
                  </h3>
                  <span className="inv-span">
                    <img src="/AppLayout/openrfi.png" className="h-[30px]" />
                  </span>
                </div>
              </Link>
              <Link
                to="/project"
                onClick={() => {
                  localStorage.setItem("activeproject", "workinprogress");
                  localStorage.setItem("projectgroupby", "Outstanding RFIs");
                }}
                className="flex flex-row border px-[0.5rem] py-[3px] rounded-md shadow-md gap-[6rem] h-12 items-center justify-between text-black no-underline hover:text-black"
                style={{ border: "1px solid #C01166" }}
              >
                <div className="dashboard-page-link">
                  <h3 className="hyperlink-name flex flex-col m-0 w-[9rem] sm:w-[9rem] md:w-[8rem] lg:w-[5.5rem] xl:w-[8rem] 2xl:w-[8rem] items-start">
                    <span style={{ color: "#C01166" }}>
                      {outstandingRfisCount}
                    </span>
                    <span className="hyperlink-span">Outstanding RFIs</span>
                  </h3>
                  <span className="inv-span">
                    <img
                      src="/AppLayout/outstanding.png"
                      className="h-[30px]"
                    />
                  </span>
                </div>
              </Link>
            </div>
          </div>
          <div className="h-[84vh] overflow-y-scroll no-scrollbar">
            <div
              className={
                isNavBarOpen
                  ? "dashboard-container"
                  : "dashboard-container-close"
              }
            >
              <div className="container-one">
                <DurationCalendar />
              </div>
              <div className="container-two">
                <GroupPieChart projects={projects} />
              </div>
            </div>
            <div
              className={
                isNavBarOpen
                  ? "dashboard-container"
                  : "dashboard-container-close"
              }
            >
              <div className="container-one">
                {" "}
                <ProjectManagerBarChart projects={projects} />
              </div>
              <div className="container-two">
                <StatusPieChart
                  projects={filterPhases}
                  statusOptions={statusOptions}
                />
              </div>
            </div>
            <div
              className={
                isNavBarOpen
                  ? "dashboard-container last-h-container"
                  : "dashboard-container-close last-h-container-close"
              }
            >
              <div className="container-one">
                {(userDetails.role_name === "Administrator" ||
                  userDetails.role_name === "Project_Manager" ||
                  userDetails.role_name === "Super Admin") && (
                  <ProjectCustomerBarChart projects={projects} />
                )}
              </div>
              <div className="container-two">
                <ul className="ul-dashboard-home">
                  {" "}
                  <ProjectTimelineSummary projects={projects} />
                </ul>
              </div>
            </div>
          </div>
          {/* <div className="h-[84vh] overflow-y-scroll no-scrollbar space-y-6 px-4">
  {[ 
    { ComponentOne: DurationCalendar, ComponentTwo: () => <GroupPieChart projects={projects} /> },
    { ComponentOne: () => <ProjectManagerBarChart projects={projects} />, ComponentTwo: () => <StatusPieChart projects={filterPhases} statusOptions={statusOptions} /> },
    { 
      ComponentOne: () =>
        (["Administrator", "Project_Manager", "Super Admin"].includes(userDetails.role_name)) && (
          <ProjectCustomerBarChart projects={projects} />
        ),
      ComponentTwo: () => <ProjectTimelineSummary projects={projects} />
    }
  ].map(({ ComponentOne, ComponentTwo }, index) => (
    <div
      key={index}
      className={`flex flex-col md:flex-row gap-4 p-4 bg-white rounded-xl shadow-md transition-all duration-300
        ${isNavBarOpen ? "w-[95%]" : "w-[99%]"}`}
    >
      <div className="flex-1">
        <ComponentOne />
      </div>
      <div className="flex-1">
        <ComponentTwo />
      </div>
    </div>
  ))}
</div> */}
        </div>
      }
    </>
  );
};

export default Home;
